import React from 'react';
import './Legal.css';

const MasterServicesAgreement = ({ isOpen, onClose }) => {
  if (!isOpen) return null;
  
  // Handle clicking outside the modal to close it
  const handleBackdropClick = (e) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };
  
  const modalBackdropStyle = {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    zIndex: 1000,
    overflow: 'auto',
    padding: '20px'
  };
  
  const containerStyle = {
    maxWidth: '800px',
    maxHeight: '80vh',
    overflowY: 'auto',
    backgroundColor: '#FFFAFA',
    borderRadius: '8px',
    boxShadow: '0 4px 20px rgba(0, 0, 0, 0.2)',
    margin: '0 auto',
    position: 'relative'
  };
  
  const closeButtonStyle = {
    position: 'absolute',
    top: '15px',
    right: '15px',
    background: 'none',
    border: 'none',
    fontSize: '24px',
    cursor: 'pointer',
    color: '#243444',
    zIndex: 10
  };
  
  const footerButtonStyle = {
    display: 'inline-block',
    backgroundColor: '#D2BA7B',
    color: '#243444',
    padding: '0.75rem 1.5rem',
    borderRadius: '8px',
    textDecoration: 'none',
    fontWeight: '600',
    transition: 'all 0.2s ease',
    boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
    border: 'none',
    cursor: 'pointer'
  };
  
  return (
    <div className="modal-backdrop" onClick={handleBackdropClick} style={modalBackdropStyle}>
      <div className="legal-container" style={containerStyle} onClick={(e) => e.stopPropagation()}>
        <button onClick={onClose} style={closeButtonStyle}>
          &times;
        </button>
        
        <div className="legal-header">
          <h1>MASTER SERVICES AGREEMENT (MSA)</h1>
          <p className="legal-effective-date">Effective Upon Acceptance</p>
        </div>
        
        <div className="legal-content">
          <p className="legal-intro" style={{ fontWeight: 'bold', marginBottom: '15px' }}>
            This Agreement governs Client's access to the Business Resilience Navigator Platform and any related services provided by PAI Consulting LLC.
          </p>
          <p className="legal-intro">
            This Master Services Agreement ("Agreement") is entered into by and between PAI Consulting LLC, an Arkansas limited liability company with its principal place of business in Little Rock, Arkansas ("Provider"), and the individual or legal entity executing this Agreement or accessing the Business Resilience Navigator platform ("Client").
          </p>
          
          <div className="legal-notice">
            <p>BY ACCESSING OR USING THE BUSINESS RESILIENCE NAVIGATOR PLATFORM, CLIENT AGREES TO BE LEGALLY BOUND BY THIS AGREEMENT. IF CLIENT DOES NOT AGREE TO THE TERMS, THEY MAY NOT ACCESS OR USE THE PLATFORM.</p>
          </div>
          
          <div className="legal-section">
            <h2>1. SERVICES</h2>
            <p>PAI Consulting LLC ("Provider") grants Client a non-exclusive, non-transferable, revocable license to access and use the Business Resilience Navigator platform ("Platform") for internal business use only. Client may use the Platform to complete assessments, generate reports, and access related content and services as specified on the Platform.</p>
          </div>
          
          <div className="legal-section">
            <h2>2. DATA USAGE & THIRD-PARTY AI INTEGRATION</h2>
            <p><strong>2.1 Client Data.</strong> Client retains ownership of all data submitted to the Platform, including assessment responses and organizational details ("Client Data").</p>
            
            <p><strong>2.2 AI Integration Disclosure.</strong> The Platform may transmit portions of Client Data to OpenAI, L.L.C., solely for the purpose of generating automated Findings & Recommendations reports.</p>
            
            <p><strong>No Data Storage by OpenAI.</strong> OpenAI does not retain or use Client Data beyond the scope of generating the requested report.</p>
            
            <p><strong>No Training Use.</strong> Client Data is not used to train any OpenAI models or stored beyond the duration of the processing session.</p>
            
            <p><strong>2.3 Consent.</strong> By using the Platform, Client expressly consents to such data processing by OpenAI or any similar third-party processor under the above conditions.</p>
          </div>
          
          <div className="legal-section">
            <h2>3. CONFIDENTIALITY</h2>
            <p>Each party agrees to maintain the confidentiality of all proprietary or confidential information disclosed under this Agreement, including Client Data and Provider methodologies. Confidentiality obligations survive termination of this Agreement.</p>
          </div>
          
          <div className="legal-section">
            <h2>4. CLIENT OBLIGATIONS</h2>
            <p>Client shall:</p>
            <ul>
              <li>Provide accurate and complete information when using the Platform.</li>
              <li>Not share login credentials with unauthorized users.</li>
              <li>Refrain from reverse engineering, decompiling, or otherwise attempting to extract source code from the Platform.</li>
            </ul>
          </div>
          
          <div className="legal-section">
            <h2>5. DISCLAIMERS</h2>
            <ul>
              <li>The Platform is provided "AS IS" and "AS AVAILABLE."</li>
              <li>Provider makes no warranties, express or implied, including warranties of merchantability, fitness for a particular purpose, or non-infringement.</li>
              <li>Generated reports are informational only and do not constitute legal or compliance advice.</li>
            </ul>
            
            <div style={{ marginTop: '15px' }}>
              <p><strong>5.1 Service Availability Disclaimer</strong></p>
              <p>PAI Consulting LLC makes commercially reasonable efforts to ensure the Platform is available without material interruption. However, the Platform is provided on an "as-is" and "as-available" basis, and Provider does not guarantee uninterrupted or error-free access.</p>
              <p>Platform availability may be affected by routine maintenance, upgrades, force majeure events, internet or hosting issues, and other circumstances beyond Provider's control.</p>
              <p>Provider will not be liable for any loss, delay, or damage arising from Platform unavailability.</p>
            </div>
          </div>
          
          <div className="legal-section">
            <h2>6. LIMITATION OF LIABILITY</h2>
            <p>To the fullest extent permitted by law:</p>
            <ul>
              <li>Provider's total liability under this Agreement shall not exceed the amount paid by Client for access to the Platform in the six (6) months preceding the claim.</li>
              <li>Provider shall not be liable for any indirect, incidental, consequential, special, or punitive damages, including loss of data, profits, or business interruption.</li>
            </ul>
          </div>
          
          <div className="legal-section">
            <h2>7. INTELLECTUAL PROPERTY</h2>
            <p>All intellectual property rights in and to the Platform, its components, content, and underlying technology are and shall remain the sole property of Provider or its licensors. This Agreement does not grant Client any ownership rights.</p>
          </div>
          
          <div className="legal-section">
            <h2>8. TERM & TERMINATION</h2>
            
            <p><strong>8.1 Term.</strong></p>
            <p>This Agreement becomes effective upon Client's acceptance and shall remain in effect until terminated as set forth below.</p>
            
            <p><strong>8.2 Termination by Client.</strong></p>
            <p>Client may terminate this Agreement at any time by ceasing all use of the Platform. No refunds shall be issued for any prepaid or unused portion of the subscription term, unless otherwise required by law.</p>
            
            <p><strong>8.3 Termination by Provider.</strong></p>
            <p>Provider may terminate this Agreement immediately upon written notice if:</p>
            <ul>
              <li>Client fails to make any payment when due;</li>
              <li>Client breaches any material term of this Agreement;</li>
              <li>Provider reasonably believes Client is misusing the Platform or violating applicable laws.</li>
            </ul>
            
            <p><strong>8.4 Effect of Termination.</strong></p>
            <p>Upon termination:</p>
            <ul>
              <li>Client's access to the Platform will be revoked;</li>
              <li>All outstanding fees shall become immediately due and payable;</li>
              <li>Provider is not obligated to retain Client Data beyond the termination date unless required by law.</li>
            </ul>
            
            <p><strong>8.5 Survival.</strong></p>
            <p>The following provisions shall survive termination: Sections 2 (Data Usage & AI Integration), 3 (Confidentiality), 5 (Disclaimers), 6 (Limitation of Liability), 7 (Intellectual Property), 8.4 (Effect of Termination), 8.5 (Survival), 9 (Governing Law), and 10 (Entire Agreement).</p>
          </div>
          
          <div className="legal-section">
            <h2>9. GOVERNING LAW</h2>
            <p>This Agreement shall be governed by the laws of the State of Arkansas, without regard to its conflict of law provisions. Any dispute shall be resolved in the courts of Pulaski County, Arkansas, and Client consents to such jurisdiction.</p>
          </div>
          
          <div className="legal-section">
            <h2>10. ENTIRE AGREEMENT</h2>
            <p>This Agreement constitutes the entire agreement between the parties and supersedes all prior oral or written agreements regarding its subject matter. Provider reserves the right to update this Agreement with or without notice (notice can be provided via banner on the application or by email to the client), and continued use of the Platform constitutes acceptance of any modifications.</p>
          </div>
          
          <div className="legal-notice">
            <p>If you do not agree to this Agreement, you must discontinue use of the Business Resilience Navigator Platform immediately.</p>
          </div>
        </div>
        
        <div className="legal-footer">
          <button onClick={onClose} style={footerButtonStyle}>
            Close
          </button>
        </div>
      </div>
    </div>
  );
};

export default MasterServicesAgreement;
